import styled from "@emotion/styled";
import "monday-ui-react-core/dist/Search.css";
import "monday-ui-react-core/dist/Menu.css";
import "monday-ui-react-core/dist/MenuItem.css";
export const StyledTemplatesNavigation = styled.div`
  .search-wrapper {
    width: 240px;
  }

  .category-list-wrapper {
    margin-top: 20px;

    .template-store-category-menu {
      .monday-style-menu-item {
        line-height: 26px;
      }
    }
  }

  .search-wrapper {
    height: 40px;
  }
`;
